import gsap from 'gsap'

import Deferred from '@/webgl/core/Deferred'
import IAnimationTrack from '@/webgl/runner/interfaces/IAnimationTrack'
import RailsRenderer from '@/webgl/runner/rendering/RailsRenderer'

type RailsRevealOptions = {
  delay: number
  reverse: boolean
}

export default class RailsRevealAnimation implements IAnimationTrack {
  clipTarget: number

  options: RailsRevealOptions

  CLIP_MAX = -11
  CLIP_TARGET = 0
  TRANSLATE = -0.15

  constructor(
    readonly rails: RailsRenderer,
    options: Partial<RailsRevealOptions> = {}
  ) {
    this.options = {
      delay: 0,
      reverse: false,
      ...options,
    }
  }

  init(): void {
    if (this.options.reverse) {
      this.clipTarget = this.CLIP_MAX
      this.rails.node.y = 0
    } else {
      this.clipTarget = this.rails.chunk.ClipMax
      this.rails.chunk.ClipMax = this.CLIP_MAX
      this.rails.node.y = this.TRANSLATE
    }
  }

  play(): Promise<unknown> {
    const defer = new Deferred<void>()

    gsap.to(this.rails.node, {
      y: 0,
      duration: 0.8,
      delay: this.options.delay,
    })

    gsap.to(this.rails.chunk, {
      ClipMax: this.clipTarget,
      duration: 1.5,
      delay: this.options.delay,
      ease: 'power2.inOut',
      onComplete: defer.resolve,
    })

    return defer.promise
  }
}
